<template>
  <b-container fluid>
    <bo-page-title />
    <section id="cta">
      <CTAType1 :modulePage="modulePage" @updateShowSection="updateShowSection(...arguments)"  /> 
      <CTAType2 :modulePage="modulePage" @updateShowSection="updateShowSection(...arguments)"  /> 
      <CTAType3 :modulePage="modulePage" @updateShowSection="updateShowSection(...arguments)"  /> 
    </section>
  </b-container>
</template>

<script>
import GlobalVue from '@/libs/Global.vue'
import Gen from '@/libs/Gen'
import CTAType1 from './CTAType1.vue'
import CTAType2 from './CTAType2.vue'
import CTAType3 from './CTAType3.vue'


export default {
  name: 'BoAboutUs',
  extends: GlobalVue,
  components: {
    CTAType1,
    CTAType2,
    CTAType3,
},
  mounted() {
    this.apiGet()
  },
  data() {
    return {     
    }
  },
  computed: {
    parent(){
      return this.$parent.$parent.$parent
    }
  },
  methods: {
    updateShowSection(value, slug, callback){

      Gen.apiRest('/do/' + this.modulePage, {data: {type: 'updateShowSetting', value, slug}}).then(res => {
        if(res){
          this.$swal({
            title: res.data.message,
            icon: 'success',
          }).then(() => {
            callback()
          })
        }
      }).catch(err => {
        this.$swal({title: err.response.data.message, icon:'error'})
      })
    },
    doDelete(v, params = {}, callback){

      let id = v[params.idKey]
      let obj = params.obj||this.$route.meta.objName
      this.$swal({
        title: 'Delete this ' + obj + '?' || 'Data' + '?',
        text: "You won't be able to restore this data!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {

          this.swalLoading()

          Gen.apiRest("/do/"+this.modulePage,{data:{type:params.type,id:id}}, "POST")
            .then((resp = {})=>{
              this.$swal({
                title: resp.data.message || 'Deleted Successfully!',
                icon: 'success',
              }).then(() => {
                callback()
              })
            })
            .catch(err=>{ 
              if(err){
                  err.statusType = err.status
                  err.status = "error"
                  err.title = err.response.data.title
                  err.message = err.response.data.message
                  err.messageError = err.message
              }
              this.doSetAlertForm(err)
            })        
        }
      })
    },
  },
  watch:{
    $route(){
      this.apiGet()
    },
  }
}
</script>./CTAType2.vue